<template>
  <button
    v-if="!href"
    :type="type"
    :form="form"
    :disabled="disabled"
    class="def-button-secondary"
    :class="{ 'def-button-secondary-big': big }"
  >
    <slot />
  </button>
  <a
    v-else
    :href="href"
    :rel="rel"
    class="def-button-secondary"
    :class="{ 'def-button-secondary-big': big }"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'DefButtonSecondary',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    href: {
      type: String,
    },
    form: String,
    rel: String,
    disabled: Boolean,
    big: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.def-button-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  letter-spacing: 1.12px;
  height: 48px;
  background-color: #b8d9ec;
  border: none;
  color: #618eaf;
  font-weight: 500;
  line-height: 100%;
  text-transform: uppercase;
  transition: 0.2s linear background-color;
  padding: 0 15px;
  cursor: pointer;
  &:hover {
    background-color: #cbe1ee;
  }
  &:disabled {
    border-color: #e5e5e5;
    color: #a8a6a6;
    cursor: not-allowed;
    background-color: #e5e5e5;
  }
}
.def-button-secondary-big {
  letter-spacing: 1.44px;
  height: 56px;
  font-size: 18px;
}
</style>
